import { ChainId } from "@/constants/chain-specific";
import type { BlockchainFarmConfig } from "./types";
import { DOGE_TOKENS, SHIB_TOKENS } from "@/constants/project-specific/tokens";
import { SOCIALS } from "@/constants/project-specific/socials";
import { DEX_LIST } from "./dex";

const chewyDex = DEX_LIST.chewyswap;
export const FARMS_CONFIG: BlockchainFarmConfig = {
  [109]: [
    {
      pid: 2,
      masterChefSlug: "chewyswap",
      lpAddress: "0x324EEf33AF720cE44DEAB7e32F4367a82b4eA43b",
      tokenA: SHIB_TOKENS.chewyswap,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 7,
      masterChefSlug: "chewyswap",
      lpAddress: "0xfC9EDB2A8F82aCA827ea0d51c916B7238196D90c",
      tokenA: SHIB_TOKENS.weth,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 24,
      masterChefSlug: "chewyswap",
      lpAddress: "0x67b9fc0Faf0123B6868c86CE27E29179c421AaC4",
      tokenA: SHIB_TOKENS.shiro,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 23,
      masterChefSlug: "chewyswap",
      lpAddress: "0x95ba5CC684Eb2E0611934a2aF64B8DC91CcE22B0",
      tokenA: SHIB_TOKENS.oscar,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 21,
      masterChefSlug: "chewyswap",
      lpAddress: "0x3764e51a7aeA95C2dF05492190e25Fb7bC4998C6",
      tokenA: SHIB_TOKENS.treat,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    // NUMNUM/TREAT FARM
    {
      pid: 22,
      masterChefSlug: "chewyswap",
      lpAddress: "0x8B542D5F6C88Af58869248a1ec84fbCFC9DB9975",
      tokenA: SHIB_TOKENS.numnum,
      tokenB: SHIB_TOKENS.treat,
      quoteToken: SHIB_TOKENS.treat,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 19,
      masterChefSlug: "chewyswap",
      lpAddress: "0x39d34dC54e47ba6f4ABb500a1f4F0Ea9DFC7FeeD",
      tokenA: SHIB_TOKENS.knbone,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 18,
      masterChefSlug: "chewyswap",
      lpAddress: "0xF3452bCdEcaDa5E08ce56EC3D2BF8e35ECFFFF91",
      tokenA: SHIB_TOKENS.knine,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 20,
      masterChefSlug: "chewyswap",
      lpAddress: "0xBa970f41F2C365A2D18E6E85a650d3D187693c79",
      tokenA: SHIB_TOKENS.snooze,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 17,
      masterChefSlug: "chewyswap",
      lpAddress: "0x3175E4412648d12d40DcA7028D37B19B57a4b048",
      tokenA: SHIB_TOKENS.cfun,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 16,
      masterChefSlug: "chewyswap",
      lpAddress: "0x3175E4412648d12d40DcA7028D37B19B57a4b048",
      tokenA: SHIB_TOKENS.cfun,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 14,
      masterChefSlug: "chewyswap",
      lpAddress: "0xFB7cC7bD5Bca846B1B7a9077365F0513585c4B91",
      tokenA: SHIB_TOKENS.skullz,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      display: "featured",
      dex: chewyDex,
    },
    {
      pid: 3,
      masterChefSlug: "chewyswap",
      lpAddress: "0x324EEf33AF720cE44DEAB7e32F4367a82b4eA43b",
      tokenA: SHIB_TOKENS.chewyswap,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 1,
      masterChefSlug: "chewyswap",
      lpAddress: "0x0E9674cff160A1aBCD57141BC8fD2E2598D99689",
      tokenA: SHIB_TOKENS.chewyswap,
      tokenB: SHIB_TOKENS.usdt,
      quoteToken: SHIB_TOKENS.usdt,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 11,
      masterChefSlug: "chewyswap",
      lpAddress: "0x47922b03239ea5E300aFF970B99cD65674e06DD4",
      tokenA: SHIB_TOKENS.leash,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 10,
      masterChefSlug: "chewyswap",
      lpAddress: "0x8888C702B7695Cc06B7F0c3f98A6C2a9a32C87D5",
      tokenA: SHIB_TOKENS.leash,
      tokenB: SHIB_TOKENS.chewyswap,
      quoteToken: SHIB_TOKENS.chewyswap,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 0,
      masterChefSlug: "chewyswap",
      lpAddress: "0xB69A4132af7495aE809Ce0155b7be1889ef72918",
      tokenA: SHIB_TOKENS.usdt,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      display: false,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 8,
      masterChefSlug: "chewyswap",
      lpAddress: "0x368616Ce3500a9ecE8708eB45d3a351990B8407a",
      tokenA: SHIB_TOKENS.shib,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      dex: chewyDex,
    },
    {
      pid: 12,
      masterChefSlug: "chewyswap",
      lpAddress: "0x8C68216B96cd89a38b693DDf566C59214CE52898",
      tokenA: SHIB_TOKENS.bonewhale,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 100,
      dex: chewyDex,
    },
    {
      // Hero-Bury Farm
      pid: 2,
      masterChefSlug: "bury",
      lpAddress: "0x493a4e305E3ae95cc7a33c6Fdb240868C8c00CD5",
      tokenA: SHIB_TOKENS.hero,
      tokenB: SHIB_TOKENS.bury,
      quoteToken: SHIB_TOKENS.bury,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Bury-Bone Farm
      pid: 3,
      masterChefSlug: "bury",
      lpAddress: "0x18da641361250942Ef13987f381BF9185C968a55",
      tokenA: SHIB_TOKENS.bury,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Hero-Bone Farm
      pid: 4,
      masterChefSlug: "bury",
      lpAddress: "0x0281188b2CFb54D0C6570c9575f5e4D90E729148",
      tokenA: SHIB_TOKENS.hero,
      tokenB: SHIB_TOKENS.wbone,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Shups Pool
      pid: 8,
      masterChefSlug: "bury",
      lpAddress: "0x39093B736eF270AF27f20f1C160b86A13f32B285",
      tokenA: SHIB_TOKENS.shups,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 1000,
      display: "featured",
      dex: chewyDex,
    },
    {
      // Hero-Bone Farm
      pid: 6,
      masterChefSlug: "bury",
      lpAddress: "0x18da641361250942Ef13987f381BF9185C968a55",
      tokenA: SHIB_TOKENS.bury,
      quoteToken: SHIB_TOKENS.wbone,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Hero-Chewy Farm
      pid: 5,
      masterChefSlug: "bury",
      lpAddress: "0xF387eAdeA5cbF069C8847aC52f8bbe56a4ACD4E2",
      tokenA: SHIB_TOKENS.hero,
      tokenB: SHIB_TOKENS.chewyswap,
      quoteToken: SHIB_TOKENS.chewyswap,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Chewyswap -  Pooshi Farm
      pid: 9,
      masterChefSlug: "chewyswap",
      lpAddress: "0x4C9f05218d9e99655C157CEe9e3341EF9FC56288",
      tokenA: SHIB_TOKENS.chewyswap,
      tokenB: SHIB_TOKENS.pooshi,
      quoteToken: SHIB_TOKENS.chewyswap,
      priority: 1000,
      dex: chewyDex,
    }
  ],
  [2000]: [
    {
      pid: 25,
      masterChefSlug: "dogeshrek",
      lpAddress: "0xc86e836292e87407060F9bf197E841F62c32fB06",
      tokenA: DOGE_TOKENS.chewyswap,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      pid: 26,
      masterChefSlug: "dogeshrek",
      lpAddress: "0x95b0186941121cAd00b226E83293aF5e385661e3",
      tokenA: DOGE_TOKENS.chewyswap,
      tokenB: DOGE_TOKENS.dc,
      quoteToken: DOGE_TOKENS.dc,
      priority: 1000,
      dex: chewyDex,
    },
    {
      pid: 24,
      masterChefSlug: "dogeshrek",
      lpAddress: "0x01Cf8f7ff4F9BBD798218DB08a42c39920138990",
      tokenA: DOGE_TOKENS.weth,
      tokenB: DOGE_TOKENS.wdoge,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      pid: 2,
      masterChefSlug: "dogeshrek",
      lpAddress: "0xD4f2E4107CC48296D25bc656bf9039fb3F406d79",
      tokenA: DOGE_TOKENS.dogeshrek,
      tokenB: DOGE_TOKENS.wdoge,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // DC-WDOGE FARM

      pid: 7,
      masterChefSlug: "dogeshrek",
      lpAddress: "0x2bcc9c4067821dd4899c2dd901c9edadb2551ce2",
      tokenA: DOGE_TOKENS.dc,
      tokenB: DOGE_TOKENS.wdoge,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // TDH-DOGE Farm
      pid: 8,
      masterChefSlug: "dogeshrek",
      lpAddress: "0x38ed98250F5fD293233eDD31CE86d9B8B2E56782",
      tokenA: DOGE_TOKENS.tdh,
      tokenB: DOGE_TOKENS.wdoge,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // OMNOM-DOGE Farm
      pid: 23,
      masterChefSlug: "dogeshrek",
      lpAddress: "0xd6DC2a7d0D1a191B911CbEfcAb5bFA6854c95A7F",
      tokenA: DOGE_TOKENS.omnom,
      tokenB: DOGE_TOKENS.wdoge,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Dogecorn-Doge

      pid: 1,
      masterChefSlug: "dogeshrek",
      lpAddress: "0x647DD9e94ac9B09eF3E3bE18C92066cEAD90Cd5C",
      tokenA: DOGE_TOKENS.dogecorn,
      tokenB: DOGE_TOKENS.wdoge,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
    {
      // Dogecorn Single Pool

      pid: 22,
      masterChefSlug: "dogeshrek",
      lpAddress: "0x647DD9e94ac9B09eF3E3bE18C92066cEAD90Cd5C",
      tokenA: DOGE_TOKENS.dogecorn,
      quoteToken: DOGE_TOKENS.wdoge,
      priority: 1000,
      dex: chewyDex,
    },
  ],
};
